export interface Criteria {
  id: string;
  brand: {
    id: string;
    name: string;
  };
  start: Date;
  end: Date;
  state?: boolean;
  brandOrder: number;
}
